import {getUnverifiedToken} from '@sail/data';
import type {StripeContextInput} from '../../../schema/types';
import {API_KEY, ID, TYPE, LIVE_MODE} from './constants';
import type {OrgUnverifiedToken} from './types';

export default function getOrgUnverifiedToken(
  id?: NonNullable<StripeContextInput['id']>,
  liveMode?: NonNullable<StripeContextInput['liveMode']>,
  apiKey?: NonNullable<StripeContextInput['apiKey']>,
): OrgUnverifiedToken {
  return {
    ...getUnverifiedToken(),
    [API_KEY]: apiKey,
    [ID]: id,
    [TYPE]: 'ORG',
    [LIVE_MODE]: liveMode,
  };
}
